<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartDataDefault"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, Filler);

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    chartData: {
      type: Object
    },
    colors: {
      type: Object,
      default: () => {
        backgroundColor: 'primary';
      }
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartDataDefault: {
        labels: [],
        datasets: [{}]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      defaultColors: {
        primary: '#26B4FF'
      }
    };
  },
  created() {
    if (this.chartData) {
      this.setChart(this.chartData);
    }
  },
  watch: {
    chartData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setChart(newVal);
        }
      },
      deep: true
    },
    colors(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.chartData.datasets = this.chartData.datasets.map((ds) => ({
          ...ds,
          backgroundColor: this.defaultColors[newVal.backgroundColor] || this.defaultColors.primary
        }));
      }
    }
  },
  methods: {
    setChart(value) {
      this.chartDataDefault = value;
    }
  }
};
</script>
